import { AlertTriangle, RefreshCw } from 'lucide-react';

interface GlobalErrorFallbackProps {
    error: unknown;
    resetErrorBoundary: () => void;
    showStackTrace?: boolean; // Optional toggle
}

export function GlobalErrorFallback({
    error,
    resetErrorBoundary,
    showStackTrace = false,
}: GlobalErrorFallbackProps) {
    const failure = error instanceof Error ? error : new Error('We could not load this page. Please try again in a moment.');
    const message = import.meta.env.PROD
        ? 'We could not load this page. Please try again in a moment.'
        : failure.message || 'We could not load this page. Please try again in a moment.';

    return (
        <div className="min-h-screen w-full bg-[var(--app-errorPageSurface)] px-6 py-12">
            <div className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-center justify-center text-center">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-amber-200 bg-amber-50 text-amber-600">
                    <AlertTriangle className="h-5 w-5" />
                </div>

                <h1 className="mb-3 text-2xl font-semibold text-darkGreen">
                    This page needs a refresh
                </h1>

                <p className="mb-6 max-w-xl text-sm leading-6 text-slateGrey">
                    {message}
                </p>

                {showStackTrace && failure.stack && (
                    <pre className="text-left text-sm bg-gray-100 dark:bg-gray-800 rounded p-4 overflow-auto text-red-500 dark:text-red-400 max-h-64 mb-6 lg:min-w-[600px]">
                        {failure.stack}
                    </pre>
                )}

                <button
                    onClick={resetErrorBoundary}
                    className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-primaryGreen px-5 text-sm font-semibold text-white shadow-sm shadow-primaryGreen/20 transition-colors hover:bg-darkGreen"
                >
                    <RefreshCw className="h-4 w-4" />
                    Refresh page
                </button>
            </div>
        </div>
    );
}
